import { render, staticRenderFns } from "./gameInfoTitle.vue?vue&type=template&id=7d718a3e&scoped=true"
import script from "./gameInfoTitle.vue?vue&type=script&lang=js"
export * from "./gameInfoTitle.vue?vue&type=script&lang=js"
import style0 from "./gameInfoTitle.vue?vue&type=style&index=0&id=7d718a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d718a3e",
  null
  
)

export default component.exports